(() => {
  function formatMoneyFromCents(cents, locale = 'pt-BR', currency = 'BRL') {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      // Fallback to BRL if currency is invalid
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
    }
  }

  function annuityPaymentCents(principalCents, monthlyRate, n) {
    if (!monthlyRate || monthlyRate <= 0) {
      return Math.round(principalCents / n);
    }
    const P = principalCents / 100; // convert to currency units for precision
    const i = monthlyRate;
    const pow = Math.pow(1 + i, n);
    const installment = (P * i * pow) / (pow - 1);
    return Math.round(installment * 100); // back to cents
  }

  function buildRows({ priceCents, maxInstallments, noInterest, interestRate }) {
    const rows = [];
    const rate = (interestRate || 0) / 100; // percent -> decimal per month

    for (let n = 1; n <= Math.max(1, maxInstallments); n++) {
      let cents;
      const isNoInterest = n <= (noInterest || 0);
      if (isNoInterest || rate === 0) {
        cents = Math.round(priceCents / n);
      } else {
        cents = annuityPaymentCents(priceCents, rate, n);
      }
      rows.push({ n, cents, isNoInterest });
    }
    return rows;
  }

  function renderGrid(container, rows) {
    const locale = container.dataset.locale || 'pt-BR';
    const currency = container.dataset.currency || 'BRL';
    const wrapper = document.createElement('div');
    wrapper.className = 'installment-grid';
    const rowsPerColumn = Math.ceil(rows.length / 2);
    wrapper.style.gridAutoFlow = 'column';
    rows.forEach(({ n, cents, isNoInterest }) => {
      const item = document.createElement('div');
      item.className = 'installment-item';

      const count = document.createElement('strong');
      count.className = 'installment-count';
      count.textContent = `${n}x`;

      const de = document.createElement('span');
      de.className = 'installment-de';
      de.textContent = 'de';

      const amount = document.createElement('strong');
      amount.className = 'installment-amount';
      amount.textContent = `${formatMoneyFromCents(cents, locale, currency)}`;

      const tail = document.createElement('span');
      tail.className = 'installment-tail';
      const fullText = window.matchMedia('(max-width: 989px)').matches;
      tail.textContent = fullText
        ? isNoInterest
          ? 'sem juros'
          : 'com juros'
        : isNoInterest
          ? 's juros'
          : 'c juros';

      // Compose with spaces: "1x de R$ 100,00 sem juros"
      item.appendChild(count);
      item.appendChild(de);
      item.appendChild(amount);
      item.appendChild(tail);

      wrapper.appendChild(item);
    });
    container.innerHTML = '';
    container.appendChild(wrapper);
  }

  function updateFromVariant(container, variant) {
    if (!container) return;
    const cfg = {
      priceCents: variant?.price ?? Number(container.dataset.priceCents || 0),
      maxInstallments: Number(container.dataset.maxInstallments || 1),
      noInterest: Number(container.dataset.noInterest || 0),
      interestRate: Number(container.dataset.interest || 0),
      locale: container.dataset.locale || 'pt-BR',
      currency: container.dataset.currency || 'BRL',
    };
    const key = `${cfg.priceCents}|${cfg.maxInstallments}|${cfg.noInterest}|${cfg.interestRate}`;
    if (container.dataset._installmentKey !== key) {
      container.dataset._installmentKey = key;
      const rows = buildRows(cfg);
      renderGrid(container, rows);
    }
    if (container.classList.contains('is-open')) {
      // Adjust height if content changed
      container.style.maxHeight = container.scrollHeight + 'px';
    }
  }

  function init(container, toggleButton) {
    if (!container) return;

    // Prepare for smooth open: use aria-hidden instead of hidden, keep collapsed
    if (container.hasAttribute('hidden')) {
      container.removeAttribute('hidden');
      container.setAttribute('aria-hidden', 'true');
    }
    container.classList.remove('is-open');
    container.style.maxHeight = '0px';

    // First render
    updateFromVariant(container, null);

    window.addEventListener('resize', () => updateFromVariant(container, null));

    // Toggle behavior with smooth animation
    const btn = toggleButton || document.getElementById('installment');
    if (btn) {
      btn.addEventListener('click', () => {
        const opening = !container.classList.contains('is-open');
        if (opening) {
          container.classList.add('is-open');
          container.setAttribute('aria-hidden', 'false');
          container.style.maxHeight = container.scrollHeight + 'px';
          const onEnd = () => {
            container.style.maxHeight = null; // let CSS control afterwards
          };
          container.addEventListener('transitionend', onEnd, { once: true });
        } else {
          // remove inline maxHeight to allow CSS to animate down
          container.style.maxHeight = null;
          container.classList.remove('is-open');
          const onEnd = () => {
            container.setAttribute('aria-hidden', 'true');
          };
          container.addEventListener('transitionend', onEnd, { once: true });
        }
        btn.setAttribute('aria-expanded', String(opening));
      });
    }

    // React to variant change (Dawn Pub/Sub)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
        updateFromVariant(container, variant);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[id^="InstallmentTable-"]');
    const btn = document.getElementById('installment');
    init(container, btn);
  });
})();
